import '/assets/styles/sections/partners.scss';
import PropTypes from 'prop-types';

// Partials
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Slider from '/views/partials/slider';

// Context
import { useBreakpoints } from '@wearetla/tla-essentials-tools/utilities/breakpoints';

// Dummy Data
import partners from '/data/partners';

const Partners = ({ id }) => {
	const { desktop } = useBreakpoints();

	return (
		<section className="section partners">
			<div className="partners-wrap wrapper narrow">
				<h2 className="partners-title">Dostlarımız</h2>

				<p className="partners-subtitle">Gönül Adamları’nın arkasında ne bir yüz, ne de kemiklerden oluşan bir vücut var; Gönül Adamları’nın arkasında “Fikir” var.</p>

				<Slider
					className="partners-slider"
					id={`${id ?? 'partners'}-slider`}
					navigation={partners.length > 7}
					params={{
						slidesPerView: desktop ? 7 : 2,
					}}>
					{partners.map((partner, nth) => (
						<div className="partners-partner" key={nth}>
							<Link
								raw
								className="partner-image"
								href={partner.link}
								title={partner.title}
								target="_blank"
								rel="noopener noreferrer">
								<Img
									className="partner-image"
									src={partner.image}
									alt={partner.title} />
							</Link>
						</div>
					))}
				</Slider>
			</div>
		</section>
	)
}

Partners.propTypes = {
	id: PropTypes.string,
}

export default Partners;